import React from "react"
import { View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"

const CustomEmptyData = (props) => {
    const { label, top, bottom } = props

    return (
        <View
            style={{
                justifyContent: "center",
                alignItems: "center",
                marginTop: top ?? 150,
                marginBottom: bottom ?? 10
            }}
        >
            <OpenSansText
                style={{ textTransform: "uppercase", color: baseColors.black }}
                defaultFontFamily={baseFontFamily.OpenSansBold}
                fontSize={RFValue(14)}
            >
                {label ?? "Aucune donnée."}
            </OpenSansText>
        </View>
    )
}

export default CustomEmptyData
